import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./inputWrapper.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function InputWrapper({
  label,
  value,
  onChangeHandler,
  name,
  readOnly = false,
  placeholder = "",
  required = false,
  labelBold = false,
  type = "text",
}) {
  return (
    <div>
      <label
        htmlFor={name}
        className={`block text-sm ${required || labelBold ? "font-bold" : ""}`}
      >
        {`${label}${required ? " (Required)" : ""}`}:
      </label>
      {type === "tel" ? (
        <PhoneInput
          placeholder={placeholder}
          defaultCountry="US"
          name={name}
          value={value}
          id={name}
          onChange={(value) => onChangeHandler(name, value)}
          className={`my-2 p-1 w-full h-9 border border-black-400 ${
            required ? "required-input font-semibold bg-yellow-200" : ""
          }`}
          readOnly={readOnly}
        />
      ) : type === "date" ? (
        <DatePicker
          selected={value}
          onChange={(date) => onChangeHandler(name, date)}
          className={`my-2 p-1 w-full h-9 border border-black-400 ${
            required ? "font-semibold bg-yellow-200" : ""
          }`}
          placeholderText={placeholder}
          readOnly={readOnly}
        />
      ) : (
        <input
          type={type}
          className={`my-2 p-1 w-full h-9 border border-black-400 ${
            required ? "font-semibold bg-yellow-200" : ""
          }`}
          name={name}
          value={value}
          placeholder={placeholder}
          id={name}
          onChange={(event) => onChangeHandler(event)}
          readOnly={readOnly}
        />
      )}
    </div>
  );
}

{
  /* <DatePicker selected={date} onChange={(date) => setDate(date)} /> */
}
